@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.row {
    & > div {
        justify-content: flex-start;

        @include breakpoint.breakpoint(layout.$belowMedium) {
            justify-content: center;
        }

        & > a {
            width: 2em;
            height: 2em;

            @include breakpoint.breakpoint(layout.$belowMedium) {
                width: 3em;
                height: 3em;
            }
        }
    }
}
